import * as React from 'react';

import RecaptchaManager from '../../RecaptchaManager';

// This is a bit hacky, but I couldn't get @types/grecaptcha to work due to redefining window.grecaptcha
interface GrecaptchaWithEnterprise {
  enterprise?: {
    execute(siteKey: string, action: string): PromiseLike<string>;
    ready(callback: () => void): void;
  };
}

export interface RecaptchaEnterpriseProps {
  sitekey: string;
  action?: string;
  renderSpinner: () => React.ReactNode;
  onLoad?: () => void;
  onRender?: () => void;
  onVerify: (a: string) => void;
  onExpire?: () => void;
  onError?: () => void;
}

export default function RecaptchaEnterprise({renderSpinner, sitekey, ...props}: RecaptchaEnterpriseProps) {
  React.useEffect(() => {
    const onReady = () => {
      const enterprise = (window?.grecaptcha as GrecaptchaWithEnterprise | undefined)?.enterprise;
      enterprise?.ready(async () => {
        const token = await enterprise.execute(
          sitekey,
          // @ts-expect-error
          props.action != null ? {action: props.action} : undefined,
        );

        props.onVerify(token);
      });
    };
    RecaptchaManager.loadRecaptchaScript(sitekey, onReady);
  }, [props, sitekey]);
  return renderSpinner();
}
